import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {IPhoneNumber} from '../../interfaces/phone-number/phone-number.interface';

@Component({
  selector: 'app-modal-cancel-appointment',
  templateUrl: './modal-cancel-appointment.component.html',
  styleUrls: ['./modal-cancel-appointment.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalCancelAppointmentComponent implements OnInit {
  @Input() isVisibleModal: boolean;
  @Input() userType: 'admin' | 'expert' | 'patient';
  @Input() clinicPhones: IPhoneNumber[] = [];
  @Input() branchPhones: IPhoneNumber[] = [];
  @Input() branchEmail: string;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  onEmitCloseModal(action: boolean): void {
    this.closeModal.emit(action);
  }

}
